import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { Overlay } from "react-bootstrap";
import { Table, Tooltip } from "tabler-react";
import { helper } from "../../utils/helpers/helper";
import Toggle from "../../component/Toggle";
import { drawingActions, mapActions } from "../../store/actions";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

let title;
// let deleteIndexList = [];
// let addIndexList = [];
function MyPolygon(props) {
  const {
    getMyGeofenceData,
    showMyPolygonList,
    getMyGeofenceDataLoading,
  } = props;
  // const [show, setShow] = useState(false);
  const [polygonsData, setPolygonsData] = useState([]);
  const [rawPolygonsData, setRawPolygonsData] = useState([]);
  const target = useRef(null);

  const handlerShow = () => {
    let localStorageSubscription = JSON.parse(
      localStorage.getItem("subscription_details")
    );
    //ACCESS TO ADMIN AND USER LEVEL 2
    if (
      localStorageSubscription?.subscription_level === null ||
      localStorageSubscription?.subscription_level === 2
    ) {
      let val = !showMyPolygonList;
      if (val === true) {
        getMyGeofenceData();
      }

      props.showMyPolygonListAction(val);
    } else {
      confirmAlert({
        // title: 'Confirm Please',
        message:
          "This feature is not included in your subscription package. Please contact WB to access this feature.",
        buttons: [
          {
            label: "Ok",
            onClick: () => {
              // DISABLE DRAWING CONTROL FROM MAP
              return null;
            },
          },
        ],
      });
    }
  };

  const handlesetRawPolygonsData = (upcomingPolygonsData) => {
    if (!helper.isEmpty(upcomingPolygonsData)) {
      setRawPolygonsData(upcomingPolygonsData);
      handlesetPolygonsData(upcomingPolygonsData);
    }
    return null;
  };

  const handlesetPolygonsData = (upcomingPolygonsData) => {
    
    if(helper.isEmpty(upcomingPolygonsData)) return null;

    var pd = upcomingPolygonsData.map(function (obj) {
      if (
        !helper.isEmpty(obj.id) &&
        !helper.isEmpty(obj.support_data?.title) &&
        !helper.isEmpty(obj.support_data?.status)
      ) {
        return {
          id: obj.id,
          title: obj.support_data.title,
          points: obj.points,
          dataset: obj,
          status: obj.support_data.status === "active" ? true : false,
          // handler: changeStatus
        };
      }
      return null;
    });
    setPolygonsData(pd);
  };
  /*
  const addPolygonsData = (index, obj) => {
    if (
      !helper.isEmpty(obj.id) &&
      !helper.isEmpty(obj.support_data?.title) &&
      !helper.isEmpty(obj.support_data?.status)
    ) {
      const pd = polygonsData;

      //PREVENT FROM DUPLICATE ENTRY
      //
      if (
        addIndexList.indexOf(index) !== -1 ||
        deleteIndexList.indexOf(index) !== -1
      )
        return null;
      //pd[0]?.id === index
      // alert(index);

      const setObj = {
        id: index,
        title: obj.support_data.title,
        status: obj.support_data.status === "active" ? true : false,
      };

      //SET RAW OBJ
      const pdRaw = rawPolygonsData;
      pdRaw.unshift(obj);
      setRawPolygonsData(pdRaw);

      //SET TOGGLE LIST
      pd.unshift(setObj);
      setPolygonsData(pd);

      // alert('ADD POLYGON');

      addIndexList.push(index);
    }

    return null;
  };

  const updatePolygon = (id, obj) => {
    if (!helper.isEmpty(id) && !helper.isEmpty(obj)) {
      const pd = polygonsData;

      //FIND INDEX NO.
      let polyUpdatingObjIndex = pd.findIndex(function (poly) {
        return poly?.id === id;
      });

      //UPDATE RECORD
      const polyUpdatingObj = {
        id: obj.id,
        title: obj.support_data.title,
        status: obj.support_data.status === "active" ? true : false,
      };

      //UPDATE RAW OBJ
      const pdRaw = rawPolygonsData;
      pdRaw[polyUpdatingObjIndex] = obj;
      setRawPolygonsData(pdRaw);

      //UPDATE TOGGLE LIST
      pd[polyUpdatingObjIndex] = polyUpdatingObj;
      setPolygonsData(pd);
    }

    return null;
  };

  const deletePolygon = (id) => {
    if (!helper.isEmpty(id)) {
      //UPDATE RAW OBJ
      const pdRaw = rawPolygonsData;
      let updatedPoly = pdRaw.filter(function (poly) {
        return poly?.id !== id && deleteIndexList.indexOf(poly?.id) === -1;
      });
      setRawPolygonsData(updatedPoly);

      //UPDATE TOGGLE LIST
      const pd = polygonsData;
      updatedPoly = pd.filter(function (poly) {
        return poly?.id !== id && deleteIndexList.indexOf(poly?.id) === -1;
      });
      setPolygonsData(updatedPoly);

      // console.log(rawPolygonsData, polygonsData);
    }

    return null;
  };
*/
  const handlerDelete = (id) => {
    handlerShow();

    confirmAlert({
      // title: 'Confirm Please',
      message: "Are you sure you want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            //CALL API
            props.deletePolygonAction(id);

            //REMOVE FROM LIST
            // deletePolygon(id);
          },
        },
        {
          label: "No",
          // onClick: () =>
        },
      ],
    });
  };

  const handlerEdit = (id) => {
    props.showMyPolygonListAction(!showMyPolygonList);

    let EditPolyObj = rawPolygonsData.filter(function (poly) {
      return poly?.id === id;
    });
    //drawEnd: set to true
    props.setPreference(EditPolyObj[0]);
  };

  const changeStatus = (polyID, status) => {
    // FIND RECORD
    let polyUpdatingObj = rawPolygonsData.filter(function (poly) {
      return poly?.id === polyID;
    });

    //UPDATE RECORD
    polyUpdatingObj = polyUpdatingObj[0];
    polyUpdatingObj.support_data.status =
      status === true ? "active" : "inactive";
    const requestData = {
      data: polyUpdatingObj,
      status: "updating",
    };
    props.updatePolygon(requestData);
  };

  const setZoom = (object, points) => {
    props.setZoomLevel(points.points);
  };
  useEffect(() => {
    //CLOSE MY POLYGONLIST
    // setShow(props.showMyPolygonList);
    // console.log("gnk", props.polyData);

    //GET ALL POLYGONS
    if (
      !helper.isEmpty(props.getMyGeofenceDataResult)
      // && addIndexList.length === 0
      // && deleteIndexList.length === 0
    ) {
      // alert('chala2');
      handlesetRawPolygonsData(props.getMyGeofenceDataResult);
      // console.log("gnk-loaded", props.getMyGeofenceDataResult);
    } else if (getMyGeofenceDataLoading !== false) {
      getMyGeofenceData();
    }

    //DELETE POLYGON
    // if (!helper.isEmpty(props.deletePolygon)) {
    //   if (
    //     !helper.isEmpty(props.deletePolygonIndex) &&
    //     deleteIndexList.indexOf(props.deletePolygonIndex) === -1
    //   ) {
    //     deleteIndexList.push(props.deletePolygonIndex);
    //     deletePolygon(props.deletePolygonIndex);
    //     // alert('deleted');
    //   }
    // }
    //UPDATE POLYGON
    // else if (!helper.isEmpty(props.updatePolygonIndex)) {
    //   // console.log("gnk-editPolygon", props.editPolygon, "editPolyData", props.editPolyData, "editPolygonIndex", props.editPolygonIndex)
    //   if (
    //     !helper.isEmpty(props.editPolygonIndex) &&
    //     !helper.isEmpty(props.editPolyData)
    //   ) {
    //     updatePolygon(props.editPolygonIndex, props.editPolyData);
    //     // alert('updated');
    //   }
    // }
    //ADD NEW CREATED POLYGON
    // else if (!helper.isEmpty(props.newPolygon)) {
    //   if (
    //     !helper.isEmpty(props.newPolyIndex) &&
    //     !helper.isEmpty(props.newPolyData) &&
    //     addIndexList.indexOf(props.newPolyIndex) === -1
    //   ) {
    //     // console.log("currentindex", props.newPolyIndex);
    //     // console.log("allindexes", props.addIndexList);
    //     // console.log("gnk2 editPolygonIndex", props.editPolygonIndex, "editPolygonData", props.newPolyData)
    //     addPolygonsData(props.newPolyIndex, props.newPolyData);
    //     // alert('created');
    //   }
    // }
  }, [props]);

  return (
    <>
      <li
        className="nav-link mypolybtn"
        ref={target}
        onClick={handlerShow}
        id="myPolygonList"
      >
        <i className="fe fe-globe"></i> Geofencing
      </li>
      <Overlay
        target={target.current}
        show={showMyPolygonList}
        placement="bottom"
      >
        {({
          placement,
          scheduleUpdate,
          arrowProps,
          outOfBoundaries,
          show: _show,
          ...props
        }) => (
          <div {...props} className="my-polygon-list">
            <Table>
              <Table.Header>
                {/* <Table.ColHeader>Active</Table.ColHeader> */}
                {/* <Table.ColHeader>Polygon</Table.ColHeader> */}
              </Table.Header>
              <Table.Body>
                {getMyGeofenceDataLoading === false &&
                polygonsData.length > 0 ? (
                  polygonsData.map(function (obj, i) {
                    title = obj?.title;
                    return (
                      <Table.Row>
                        <Table.Col>
                          <Toggle
                            name="status"
                            // label={title.substring(0,15)}
                            label={title}
                            // className=""
                            value={obj?.id}
                            onChange={changeStatus}
                            // obj={obj}
                            isChecked={obj?.status}
                          />
                          <div className="tools">
                            <Tooltip content="Zoom" placement="top">
                              <button
                                className="btn btn-link link-success zoomToMarker"
                                onClick={(event) => setZoom(event, obj)}
                              >
                                <i className="fe fe-zoom-in"></i>
                              </button>
                            </Tooltip>
                            <Tooltip content="Edit" placement="top">
                              <button
                                className="btn btn-link link-success"
                                onClick={() => {
                                  handlerEdit(obj.id);
                                }}
                              >
                                <i className="fe fe-edit"></i>
                              </button>
                            </Tooltip>

                            <Tooltip content="Delete" placement="top">
                              <button
                                className="btn btn-link link-success"
                                onClick={() => {
                                  handlerDelete(obj.id);
                                }}
                              >
                                <i className="fe fe-trash-2"></i>
                              </button>
                            </Tooltip>
                          </div>
                        </Table.Col>
                        {/* <Table.Col>{helper.ucfirst(obj.title)}</Table.Col> */}
                      </Table.Row>
                    );
                  })
                ) : (
                  <span className="no-polygon-default">
                    {getMyGeofenceDataLoading ? (
                      <Loader
                        type="ThreeDots"
                        color="#94a869"
                        height={100}
                        width={100}
                        timeout={1000} //3 secs
                      />
                    ) : (
                      "Please create a geofence to view"
                    )}
                  </span>
                )}
              </Table.Body>
            </Table>
          </div>
        )}
      </Overlay>
    </>
  );
}

function mapStateToProps(state) {
  const {
    polyData,
    newPolyIndex,
    newPolygon,
    newPolyData,
    deletePolygon,
    deletePolygonIndex,
    editPolygon,
    updatePolygonIndex,
    editPolygonIndex,
    editPolyData,
  } = state.drawing;
  const {
    showMyPolygonList,
    getMyGeofenceDataResult,
    getMyGeofenceDataLoading,
  } = state.map;
  return {
    polyData,
    newPolygon,
    newPolyIndex,
    newPolyData,
    editPolygon,
    editPolygonIndex,
    editPolyData,
    deletePolygon,
    deletePolygonIndex,
    showMyPolygonList,
    updatePolygonIndex,
    getMyGeofenceDataResult,
    getMyGeofenceDataLoading,
  };
}

const mapDispatchToProps = {
  updatePolygon: drawingActions.updatePolygon,
  deletePolygonAction: drawingActions.deletePolygon,
  setPreference: drawingActions.setPreference,
  showMyPolygonListAction: mapActions.showMyPolygonListAction,
  setZoomLevel: mapActions.setZoomLevel,
  getMyGeofenceData: mapActions.getMyGeofenceData,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyPolygon);
